export const PATH_BASE = "/";
export const PATH_ADMIN = "/admin";

export const PATH_DASHBOARD = "/";
export const PATH_SIGN_IN = "/login";
export const PATH_SIGN_UP = "/register";

export const PATH_NOT_FOUND = "/404";


export const getFullAdminPath = (x) => {

    return PATH_ADMIN+x;

}


// TRENDYOL
export const PATH_T_CONTROL_PANEL = "/tcontrolpanel";
export const PATH_H_CONTROL_PANEL = "/hcontrolpanel";
export const PATH_A_CONTROL_PANEL = "/acontrolpanel";
export const PATH_T_CONTROL_PANEL_ADMIN = "/tcontrolpaneladmin";
export const PATH_H_CONTROL_PANEL_ADMIN = "/hcontrolpaneladmin";
export const PATH_A_CONTROL_PANEL_ADMIN = "/acontrolpaneladmin";
export const PATH_T_DETAILS = "/tdetails";
export const PATH_H_DETAILS = "/hdetails";
export const PATH_A_DETAILS = "/adetails";
export const PATH_T_SDETAILS = "/tsdetails";
export const PATH_H_SDETAILS = "/hsdetails";
export const PATH_A_SDETAILS = "/asdetails";
export const PATH_T_EDETAILS = "/teddetails";
export const PATH_H_EDETAILS = "/heddetails";
export const PATH_A_EDETAILS = "/aeddetails";
export const PATH_T_CARD_DETAIL = "/card-detail";
export const PATH_H_CARD_DETAIL = "/h-card-detail";
export const PATH_A_CARD_DETAIL = "/a-card-detail";
export const PATH_T_SCARD_DETAIL = "/scard-detail";
export const PATH_H_SCARD_DETAIL = "/h-scard-detail";
export const PATH_A_SCARD_DETAIL = "/a-scard-detail";
// ELEKTRONİK (MediaMarkt + Vatan)
export const PATH_E_DETAILS = "/edetails";
export const PATH_E_SDETAILS = "/esdetails";
export const PATH_E_CARD_DETAIL = "/e-card-detail";
export const PATH_E_SCARD_DETAIL = "/e-scard-detail";
export const PATH_E_CONTROL_PANEL = "/econtrolpanel";
export const PATH_E_CONTROL_PANEL_ADMIN = "/econtrolpaneladmin";

export const PATH_N_DETAILS = "/ndetails";
export const PATH_N_SDETAILS = "/nsdetails";
export const PATH_N_CARD_DETAIL = "/n-card-detail";
export const PATH_N_SCARD_DETAIL = "/n-scard-detail";
export const PATH_N_CONTROL_PANEL = "/ncontrolpanel";
export const PATH_N_CONTROL_PANEL_ADMIN = "/ncontrolpaneladmin";
export const PATH_PZ_DETAILS = "/pzdetails";
export const PATH_PZ_SDETAILS = "/pzsdetails";
export const PATH_PZ_CARD_DETAIL = "/pz-card-detail";
export const PATH_PZ_SCARD_DETAIL = "/pz-scard-detail";
export const PATH_PZ_CONTROL_PANEL = "/pzcontrolpanel";
export const PATH_PZ_CONTROL_PANEL_ADMIN = "/pzcontrolpaneladmin";
export const PATH_IX_DETAILS = "/ixdetails";
export const PATH_IX_SDETAILS = "/ixsdetails";
export const PATH_IX_CARD_DETAIL = "/ix-card-detail";
export const PATH_IX_SCARD_DETAIL = "/ix-scard-detail";
export const PATH_IX_CONTROL_PANEL = "/ixcontrolpanel";
export const PATH_IX_CONTROL_PANEL_ADMIN = "/ixcontrolpaneladmin";
export const PATH_T_KATEGORI_DETAILS = "/tkategoridetails";
export const PATH_KODLAR_ADMIN = "/kodlar";
export const PATH_REKLAM_STUDYOSU = "/reklam";
export const PATH_ESLESTIRME_ADMIN = "/eslestirme";          // katalog: ürün eşleştirme onay kuyruğu
export const PATH_KATEGORI_ESLEME_ADMIN = "/kategori-esleme"; // katalog: mağaza kategorisi → ortak kategori

export const PATH_REDIRECT = "/redirect";